/*
 * cep-memoria.js — o CEP digitado uma vez vale para a loja inteira.
 *
 * A loja tem CINCO campos de CEP independentes, cada um com a propria
 * calculadora, nascidos em momentos diferentes:
 *   #Pp2Cep       PDP v3            (sections/product-page-v2.liquid)
 *   .js-zip       carrinho, drawer e PDP antiga (snippets/shipping-calculator.liquid)
 *   #PdpCep       pagina da Duna    (sections/duna-lp-3.liquid)
 *   #BitesCep     LP dos Bites      (assets/bites-lp.js)
 *   #sp-cep-input LP de Sao Paulo   (sections/sp-entrega-hoje.liquid)
 * Nenhum guardava nada, entao o cliente redigitava o mesmo CEP ate cinco vezes
 * na mesma visita.
 *
 * Este modulo NAO calcula frete: so lembra o ultimo CEP valido e preenche campo
 * VAZIO. Cada calculadora continua dona da logica dela, e nada aqui dispara
 * cotacao (a da PDP adiciona o produto ao carrinho pra cotar e depois remove;
 * rodar isso sozinho em todo carregamento seria caro e arriscado).
 *
 * Guardamos MASCARADO (00000-000): conferi uma a uma, as cinco fazem
 * replace(/\D/g, '') antes de usar, entao a mascara e segura, e e exatamente o
 * formato que o proprio campo produz enquanto o cliente digita.
 */
(function () {
  'use strict';

  var CHAVE = 'woolie_cep';
  var CAMPOS = '#Pp2Cep, #PdpCep, #BitesCep, #sp-cep-input, .js-zip';

  function ler() {
    try {
      var v = window.localStorage.getItem(CHAVE) || '';
      return /^\d{5}-\d{3}$/.test(v) ? v : '';
    } catch (e) { return ''; } // navegacao privada ou storage bloqueado
  }

  function salvar(cep) {
    try { window.localStorage.setItem(CHAVE, cep); } catch (e) {}
  }

  function mascarar(bruto) {
    var d = String(bruto || '').replace(/\D/g, '').slice(0, 8);
    return d.length === 8 ? d.slice(0, 5) + '-' + d.slice(5) : '';
  }

  function preencher(campo) {
    if (!campo) return;
    if (campo.value) return;             // nunca sobrescreve o que o cliente digitou
    if (campo.dataset.cepMemoria) return; // ja tratado: se ele apagou, respeita
    var cep = ler();
    if (!cep) return;
    campo.dataset.cepMemoria = '1';
    campo.value = cep;
  }

  function varrer(raiz) {
    if (!raiz) return;
    if (raiz.nodeType !== 1 && raiz.nodeType !== 9) return;
    if (raiz.matches && raiz.matches(CAMPOS)) preencher(raiz);
    if (!raiz.querySelectorAll) return;
    Array.prototype.forEach.call(raiz.querySelectorAll(CAMPOS), preencher);
  }

  // Salva assim que o cliente completa os 8 digitos, em qualquer um dos campos.
  // Captura no topo pra funcionar mesmo em campo criado depois (drawer).
  document.addEventListener('input', function (e) {
    var alvo = e.target;
    if (!alvo || !alvo.closest) return;
    var campo = alvo.closest(CAMPOS);
    if (!campo) return;
    var cep = mascarar(campo.value);
    if (cep) salvar(cep);
  }, true);

  function iniciar() {
    varrer(document);
    // O drawer do carrinho REFAZ o proprio HTML a cada add (renderContents),
    // destruindo e recriando o campo. Preencher so no load nao pegaria justamente
    // o caso mais comum: produto -> adicionar -> drawer abre com o campo vazio.
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var novos = muts[i].addedNodes;
          for (var j = 0; j < novos.length; j++) varrer(novos[j]);
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
